import { Component, computed, inject, input, output } from "@angular/core";
import { KENDO_DIALOGS, WindowState } from "@progress/kendo-angular-dialog";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { FormsModule } from "@angular/forms";
import { CustomMessagesService } from "../../services/custom-messages.service";
import { WINDOW_HEIGHT, WINDOW_WIDTH } from "../../app.const";
import { WindowTitlebarComponent } from "../window-titlebar/window-titlebar.component";

@Component({
  selector: "app-confirmation-delete",
  imports: [KENDO_DIALOGS, FormsModule, WindowTitlebarComponent],
  providers: [{ provide: ICON_SETTINGS, useValue: { type: "svg" } }],
  templateUrl: "./confirmation-delete.component.html",
  styleUrl: "./confirmation-delete.component.scss",
})
export class ConfirmationDeleteComponent {
  protected readonly customMessagesService = inject(CustomMessagesService);

  msg = input.required<string>();
  childConfirmationDelete = input.required<number>();
  closed = output<boolean>();

  message = computed(() =>
    this.customMessagesService
      .translate("confirmation_delete_question")
      .replace("{VAR}", this.msg()),
  );

  messageChild = computed(() => {
    const count = this.childConfirmationDelete();

    if (count === 0) return "";

    const key =
      count === 1
        ? "confirmation_delete_enfant"
        : "confirmation_delete_enfants";

    return this.customMessagesService
      .translate(key)
      .replace("{VAR}", String(count));
  });

  public windowState: WindowState = "default";
  public windowWidth = WINDOW_WIDTH;
  public windowHeight = WINDOW_HEIGHT;

  oui(): void {
    this.closed.emit(true);
  }

  close(): void {
    this.closed.emit(false);
  }
}
